export const DEFAULT_PARTNER_ID: string = 'main';